import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './RemoteStartInformation.module.scss';
import 'src/css/themes.scss';
import { IconSeeMore } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { Dialog, ScrollBar } from '@framework-controls/core';
import { strings } from 'src/localization';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
}

const RemoteStartInformation = (props: IProps) => {
    const [infoOpen, setInfoOpen] = useState(false);
    const toggleInfo = useCallback(() => {
        setInfoOpen(!infoOpen);
    }, [infoOpen]);

    let command: ReactElement | null = null;
    if (props.connectedVehicle.remStartStatusValue) {
        let remStartValue = strings.No;
        if (props.connectedVehicle.remStartStatusValue === 'Y') {
            remStartValue = strings.Yes;
        }
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.remStartStatusStatus) {
            statusLit = props.connectedVehicle.remStartStatusStatus + ' ' + strings.AsOf;
        }
        let remoteTstamp: ReactElement | null = null;
        if (props.connectedVehicle.remStartStatusTstamp) {
            remoteTstamp =
                <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.remStartStatusTstamp}</p>;
        }
        command =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.RemoteStartCommand}
                </div>
                <div className={css.infoData}>
                    {remStartValue}
                </div>
                {remoteTstamp}
            </span>;
    }

    let duration: ReactElement | null = null;
    if (props.connectedVehicle.remStartDuration || props.connectedVehicle.remStartTimeRemain) {
        let remoteStartLit: string | null = null;
        let remoteStartValue: string | null = null;
        if (props.connectedVehicle.remStartDuration && props.connectedVehicle.remStartTimeRemain) {
            remoteStartLit = strings.RemoteStart + ' ' + strings.Duration + '/' + strings.TimeRemaining;
            remoteStartValue = props.connectedVehicle.remStartDuration + '/' + props.connectedVehicle.remStartTimeRemain;
        }
        if (!props.connectedVehicle.remStartDuration) {
            remoteStartLit = strings.TimeRemaining;
            remoteStartValue = props.connectedVehicle.remStartTimeRemain;
        }
        if (!props.connectedVehicle.remStartTimeRemain) {
            remoteStartLit = strings.Duration;
            remoteStartValue = props.connectedVehicle.remStartDuration;
        }
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.remStartStatus) {
            statusLit = props.connectedVehicle.remStartStatus + ' ' + strings.AsOf;
        }
        let durationTstamp: ReactElement | null = null;
        if (props.connectedVehicle.remStartTstamp) {
            durationTstamp =
                <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.remStartTstamp}</p>;
        }
        duration =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {remoteStartLit}
                </div>
                <div className={css.infoData}>
                    {remoteStartValue}
                </div>
                {durationTstamp}
            </span>;
    }

    return (
        <div className={css.block}>
            <div className={css.icon}>
                <IconSeeMore onClick={() => toggleInfo()} />
            </div>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={infoOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.RemoteStartInformation.toUpperCase()}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={() => toggleInfo()}
                onBackDropClick={() => toggleInfo()}
                width={'full'}
            >
                <ScrollBar scrollVertical>
                    <div className={css.infoRow}>
                        {command}
                        {duration}
                    </div>
                </ScrollBar>
            </Dialog>
        </div>
    );
};

export default RemoteStartInformation;